<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import BenefitsStrip from "./BenefitsStrip.svelte";
	import translations from "./FathersClubBenefitsSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<BenefitsStrip items={[translate("moreBeneficial"), translate("freeDelivery"), translate("withoutObligation")]} />
